import { render, staticRenderFns } from "./erm_event_help.vue?vue&type=template&id=d1a748e2&scoped=true&"
import script from "./erm_event_help.vue?vue&type=script&lang=js&"
export * from "./erm_event_help.vue?vue&type=script&lang=js&"
import style0 from "./erm_event_help.vue?vue&type=style&index=0&id=d1a748e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1a748e2",
  null
  
)

export default component.exports